module.exports = __webpack_public_path__ + "img/hot.027b74ad.gif";